import angular from 'angular'

require('window').__drac = {
  debug: true,
}

// import "blueimp-file-upload/js/vendor/jquery.ui.widget"
// import "blueimp-file-upload/js/jquery.fileupload"

// import "./../unici-index"
import './play-candidato-app'
import './play-candidato-mod'

import './candidato-app/play-app.component'

angular.bootstrap('body', ['CandidatoPlay'], { strictDi: true })

console.log('booooootstrap')

import './styles/index--styles.scss'
// import "materialize-css/dist/js/materialize.min.js"
// import "materialize-css/dist/js/materialize.js"

import '../_vendor/materialize-css/materialize.js'
